import { MapperHelper } from '@helpers';

import { RadioGroup } from '../RadioButton/RadioGroup';

import styles from './TableRadioGroup.module.scss';

interface NumberInputGroupEntry {
  description: string;
}

interface NumberInputGroupProps {
  groupDescription?: string | React.ReactNode;
  options: NumberInputGroupEntry[];
  values: (number | undefined)[];
  onChange: (newValues: (number | undefined)[]) => void;
}

export const TableRadioGroup: React.FC<NumberInputGroupProps> = ({
  groupDescription,
  options,
  values,
  onChange,
}: // size,
NumberInputGroupProps) => {
  if (values?.length !== options.length) {
    console.error(
      `Number input group with description '${groupDescription}' expected every option to have one value, but there are ${options.length} options and ${values?.length} values?.`,
    );
  }

  return (
    <div className={styles.table}>
      <li className={styles.description}>{groupDescription}</li>
      <ul className={styles.tableGroup}>
        <div className={styles.inputItem}>
          <div />
          <div className={styles.headerLabels}>
            <div>not started</div>
            <div>in progress</div>
            <div>done/not applicable</div>
          </div>
        </div>
        {options.map(({ description }, index) => (
          <li key={description}>
            <div className={styles.inputItem}>
              <div className={styles.itemDescription}>{description}</div>
              <div className={styles.radioButtons}>
                <RadioGroup
                  options={[
                    { id: 0, name: '' },
                    { id: 1, name: '' },
                    { id: 2, name: '' },
                  ]}
                  onSelect={value => {
                    if (values[index] !== value) {
                      onChange(MapperHelper.replaceItemAt(index, value, values));
                    }
                  }}
                  inputProps={{ defaultValue: values[index] }}
                  isTable
                />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
